import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "no-scrollbar grid w-full grid-cols-2 gap-4 overflow-x-auto overflow-y-hidden md:w-auto md:grid-cols-3 lg:shrink-0" }

import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import type { Company } from '@/types';
    import CustomerInvoices from './CustomerInvoices.vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import { useDashboardStore } from '@/stores/dashboard';
    import CustomerDashboardStatItem from './CustomerDashboardStatItem.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboardStats',
  props: {
    company: {}
  },
  setup(__props: any) {

    const { t } = useI18n();
    const { hasPermission } = usePermissions();
    const dashboardStore = useDashboardStore();

    const props = __props;

    const translatedUniqueWorkDays = computed(() => {
        return dashboardStore.uniqueWorkDays.map((day) => {
            return t(`task-templates.days_in_week.${day}`);
        });
    });

    const stats = computed(() => {
        return [
            {
                value: dashboardStore.procedureCount,
                description: t('dashboards.customer_stats.procedures'),
                icon: 'FileChartLine',
            },
            {
                value: t('dashboards.customer_stats.work_days', {
                    count: dashboardStore.uniqueWorkDays.length,
                }),
                description: t('dashboards.customer_stats.weekdays', {
                    days: translatedUniqueWorkDays.value.join(', '),
                }),
                icon: 'CircleArrowUp',
            },
            {
                value: props.company.vouchers_count,
                description: t('dashboards.customer_stats.missing_vouchers'),
                icon: 'Archive',
                href: hasPermission(Permission.VOUCHERS_VIEW)
                    ? route('v2.vouchers.index', { company_id: props.company.id })
                    : undefined,
            },
            {
                value: props.company.services?.vat_frequency
                    ? t(`companies.vat_frequency_options.${props.company.services.vat_frequency}`)
                    : '-',
                description: t('dashboards.customer_stats.vat_frequency'),
                icon: 'Calculator',
            },
            {
                value: dashboardStore.taskCount,
                description: t('dashboards.customer_stats.actual_tasks'),
                icon: 'ClipboardList',
            },
        ];
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomerInvoices, {
      company: props.company
    }, null, 8, ["company"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value, (stat) => {
      return (_openBlock(), _createBlock(CustomerDashboardStatItem, { stat: stat }, null, 8, ["stat"]))
    }), 256))
  ]))
}
}

})